export const capitaliseFirstLetter = (str?: string) =>
  !str ? '' : `${str.substr(0, 1).toUpperCase()}${str.substr(1).toLowerCase()}`;
export const titleCase = (str?: string) =>
  !str
    ? ''
    : str
        .split(' ')
        .map((token) => capitaliseFirstLetter(token))
        .join(' ');
